import { Row, Col, FormGroup } from 'react-bootstrap';
import React, { Component } from 'react';
import FormularioPadrao from './../FormularioPadrao';
import Label from '../../components/Label';
import TextInput from '../../components/TextInput';
import InstaladorNeosController from '../../controllers/Neos/InstaladorNeosController';
import { updateState } from '../../utils/Functions';
import Document from '../../components/Document';

export default class InstaladorNeosView extends Component {
  constructor(props) {
    super(props);
    this.state = { mostrarAcessos: true };
    this.controller = new InstaladorNeosController(this);
  }

  renderizarFormulario = () => {
    const tela = this.props.lang.telaDeCadastroDeInstalador || {};
    const item = this.state.itemSelecionado || {};

    return (
      <React.Fragment>
        <Row>
          <Col sm={3} md={3} lg={3}>
            <FormGroup>
              <Label>{this.props.lang.codigo}</Label>
              <input 
              className="form-control" 
              readOnly 
              value={item?.id ?? ''} 
              />
            </FormGroup>
          </Col>

          <Col sm={3} md={3} lg={3}>
            <FormGroup>
              <Label>{tela.tipoDeInstalador}</Label>
              <select
                className="form-control"
                value={item.tipoDeInstalador}
                onChange={(e) => {
                  updateState(this, (state) => {
                    state.itemSelecionado.tipoDeInstalador = e.target.value;
                  });
                }}
              >
                <option value={this.props.lang.telaDeCadastroDeInstalador?.aplicativo}>Aplicativo</option>
                <option value={this.props.lang.telaDeCadastroDeInstalador?.desktop}>Desktop</option>
              </select>
            </FormGroup>
          </Col>

          <Col sm={3} md={3} lg={3}>
            <FormGroup>
              <Label>{tela.numeroDaVersao}</Label>
              <input
                className="form-control"
                value={item?.numeroDaVersao ?? ''}
                onChange={(e) => {
                  updateState(this, (state) => {
                    state.itemSelecionado.numeroDaVersao = e.target.value;
                  });
                }}
              />
            </FormGroup>
          </Col>

          <Col sm={3} md={3} lg={3}>
            <FormGroup>
              <Label>{tela.dataDeLiberacao}</Label>
              <input
                className="form-control"
                type="date"
                value={(item.dataDeLiberacao).split('T')[0]}
                onChange={(e) => {
                  updateState(this, (state) => {
                    state.itemSelecionado.dataDeLiberacao = e.target.value;
                  });
                }}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col sm={12} md={12} lg={12}>
            <FormGroup>
              <Label>{tela.alteracoes}</Label>
              <textarea
                className="form-control"
                rows={3}
                style={{ resize: 'vertical', maxHeight: 160 }}
                value={item.alteracoes}
                onChange={(e) => {
                  updateState(this, (state) => {
                    state.itemSelecionado.alteracoes = e.target.value;
                  });
                }}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col sm={12} md={12} lg={12}>
            <FormGroup>
              <Label>{tela.arquivo}</Label>
              <Document
                    lang={this.props.lang}
                    api={this.props.api}
                    maxSize={20 * 1024 * 1024}
                    accept="*/*"
                    defaultValue={this.state.itemSelecionado?.arquivoDeInstalacao}
                    onChange={(file) => {
                    updateState(this, (state) => {
                        if (state.itemSelecionado) {
                          state.itemSelecionado.arquivoDeInstalacao  = file;
                        }
                    });
                    }}
                />
            </FormGroup>
          </Col>
        </Row>
      </React.Fragment>
    );
  };

  render() {
    return (
      <FormularioPadrao
        titulo={this.props.lang.telaDeConsultaDeInstaladores?.instaladores}
        url={'/instalador'}
        api={this.props.api}
        lang={this.props.lang}
        permissoes={[1471, 1472, 1473, 1474]}
        getFiltro={this.controller.getFiltro}
        getTitulosDaTabela={this.controller.getTitulosDaTabela}
        getDadosDaTabela={this.controller.getDadosDaTabela}
        renderizarFormulario={this.renderizarFormulario}
        getObjetoDeDados={this.controller.getObjetoDeDados}
        antesDeInserir={this.controller.antesDeInserir}
        antesDeEditar={this.controller.antesDeEditar}
        antesDeSalvar={this.controller.antesDeSalvar}
        antesDeExcluir={this.controller.antesDeExcluir}
        getFormState={() => this.state}
        setFormState={(state, callback) => {
          return new Promise((resolve) => {
            this.setState(state, () => {
              resolve();
              if (callback) callback();
            });
          });
        }}
        select={this.props.select}
        itemVazio={{
          numeroDaVersao: '',
          dataDeLiberacao: '',
          alteracoes: '',
          tipoDeInstalador: 'Aplicativo',
          __file: null,
        }}
      />
    );
  }
}
